import { Outlet, createBrowserRouter } from "react-router-dom";
import { Login } from "./login/login";
import { ProtectedView } from "../components/protected-view";
import { Zones } from "./zones/zones";
import { Stores } from "./stores/stores";
import { ZoneLayout } from "./zone-layout";
import { MobileAppCheckout } from "./mobile-app-checkout";

export const router = createBrowserRouter([
  {
    path: "/",
    element: <ProtectedView />,
    children: [
      {
        path: "stores",
        element: <Stores />,
      },
      {
        path: "stores/:storeKey",
        element: <Outlet />,
        children: [
          {
            index: true,
            element: <Zones />,
          },

          {
            path: "zones/:zoneId",
            element: <ZoneLayout />,
            children: [
              {
                path: "mobile-app",
                children: [
                  {
                    index: true,
                    element: <MobileAppCheckout />,
                  },
                ],
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: "/login",
    element: <Login />,
  },
]);
